module.exports = __webpack_public_path__ + "static/media/kirby.c263769d.png";